import { TImprovedContentMarketing } from '../../../../../../shared/types/contentMarketing';
import * as React from 'react';
import VerticalBlock from '../../../blocks/vertical-block';
import { MultiWrapper } from '../../../multi-wrapper';
import FabricAnchorCard from '../../../components/fabric-anchor-card';

const RealEstateSectionMulti = ({ contentMarketingList, placementId }) => {
    return (
        <MultiWrapper
            placementId={placementId}
            contentMarketingList={contentMarketingList}
            containerClassName={'my-16'}
            flexGap={'gap-8'}
        >
            {(contentMarketing: TImprovedContentMarketing, i: number) => (
                <FabricAnchorCard
                    contentMarketing={contentMarketing}
                    key={i}
                    className={'h-full'}
                >
                    <VerticalBlock
                        isMultipleAds={true}
                        contentMarketing={contentMarketing}
                    />
                </FabricAnchorCard>
            )}
        </MultiWrapper>
    );
};

export default RealEstateSectionMulti;
